import React from "react";
import "../../components/common/erpForm.css";

export default function BasicInfoTab({ form, setForm }) {
  return (
    <div>
      <div className="erp-section">
        <div className="erp-section-title">
          General Information
        </div>

        <div className="erp-form-grid">
          <div className="erp-field">
            <label>BP Code</label>
            <input value="Auto" disabled />
          </div>

          <div className="erp-field">
            <label>Partner Type *</label>
            <select
              value={form.partner_type}
              onChange={(e) =>
                setForm({
                  ...form,
                  partner_type: e.target.value,
                })
              }
            >
              <option value="ORGANIZATION">
                Organization
              </option>
              <option value="INDIVIDUAL">
                Individual
              </option>
            </select>
          </div>

          <div className="erp-field">
            <label>Partner Name *</label>
            <input
              value={form.name}
              onChange={(e) =>
                setForm({
                  ...form,
                  name: e.target.value,
                })
              }
            />
          </div>

          <div className="erp-field">
            <label>Status</label>
            <select
              value={form.status}
              onChange={(e) =>
                setForm({
                  ...form,
                  status: e.target.value,
                })
              }
            >
              <option value="ACTIVE">Active</option>
              <option value="INACTIVE">Inactive</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}
